var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{staticClass:"center mt30",attrs:{"background":"","current-page":_vm.modelvalue,"layout":"prev, pager, next","total":_vm.total,"page-size":_vm.pageSize,"hide-on-single-page":""},on:{"current-change":_vm.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }